import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  // useTheme,
  // useMediaQuery
} from '@mui/material';
import {
  LocalShipping as ShippingIcon,
  Payment as PaymentIcon,
  Support as SupportIcon,
  Cached as ReturnIcon
} from '@mui/icons-material';

// معلومات الشريط
const infoItems = [
  {
    id: 1,
    icon: ShippingIcon,
    title: 'شحن مجاني',
    description: 'للطلبات فوق 200 ريال'
  },
  {
    id: 2,
    icon: PaymentIcon,
    title: 'دفع آمن',
    description: 'جميع وسائل الدفع متاحة'
  },
  {
    id: 3,
    icon: SupportIcon,
    title: 'دعم على مدار الساعة',
    description: 'تواصل معنا في أي وقت'
  },
  {
    id: 4,
    icon: ReturnIcon,
    title: 'ضمان استرجاع',
    description: 'استرجاع خلال 14 يوم'
  }
];

const InfoBar: React.FC = () => {
  // يمكن استخدام هذه المتغيرات لاحقاً لتحسين تجربة المستخدم على الأجهزة المحمولة
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        py: 4,
        backgroundColor: '#fff',
        borderTop: '1px solid #eee',
        borderBottom: '1px solid #eee',
        width: '100vw',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)'
      }}
    >
      <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4, lg: 5 } }}>
        <Grid container spacing={3}>
          {infoItems.map((item) => {
            const IconComponent = item.icon;

            return (
              <Grid item xs={6} md={3} key={item.id}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: { xs: 'center', sm: 'flex-start' },
                    textAlign: { xs: 'center', sm: 'right' },
                    height: '100%'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      backgroundColor: 'primary.light',
                      color: 'primary.main',
                      mb: { xs: 1, sm: 0 },
                      mr: { xs: 0, sm: 2 }
                    }}
                  >
                    <IconComponent sx={{ fontSize: 28 }} />
                  </Box>

                  <Box>
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '1rem', md: '1.25rem' }
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        fontSize: { xs: '0.75rem', md: '0.875rem' }
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default InfoBar;
